const Chiropractors = [
  {
    hideHeading: true,
  },
  {
    tag: 'h2',
    heading: 'Why should I hire a professional locksmith?',
    description: `Unfortunately, while some tradespeople may describe themselves as locksmiths, this does not mean they are fully insured, police-checked, or even qualified.
  <br><br>
  By choosing a locksmith approved by the MLAA, you can be sure the tradesperson will be trade qualified, highly skilled, and working under a strict code of ethics. Professional and qualified locksmiths will never falsely advertise their skills or provide untrustworthy advice.
  <br><br>
  Qualified locksmiths have expert knowledge in all areas of security, including automotive, industrial, commercial, and residential. Whether you’re locked out of your home or have lost your car keys, calling a licensed locksmith is always the safest option.
  <br><br>
  Many people have experienced the stress of locking themselves out of their house. Generally, when this happens, there are three options—calling a locksmith, trying to pick the lock yourself, or breaking a window. Only one of these options is safe, affordable, and foolproof. Can you guess what it is?
  <br><br>
  Trying to pick a lock or force open a locked door can lead to further damage, requiring costly repairs. You’ll also end up needing to contact a locksmith anyway to fix your broken lock! Breaking windows, similarly, is dangerous and will require costly window repair or replacement. In any case, simply calling a locksmith the moment you realise you’ve locked yourself out is the safest and cheapest option.
  <br><br>
  By searching ‘locksmith near me’ on your smartphone, you’ll quickly find a local locksmith to solve your problem. Just make sure you choose a qualified <a href="https://www.masterlocksmiths.com.au" target="_blank">Master Locksmith</a>!
  `,
  },
  {
    tag: 'h2',
    heading: 'What can a locksmith do?',
    description: `Locksmiths are responsible for a branching range of tasks, beyond simply picking locks or cutting keys. These responsibilities range from small-scale jobs like opening car locks, to large-scale undertakings like installing electronic security systems for commercial and industrial spaces.`,
    faqs: [
      {
        tag: 'h3',
        q: `Unlock doors`,
        a: `Locksmiths have the skills and tools on-hand to open almost any door lock. Qualified locksmiths will begin by attempting to pick the lock without causing any damage. If lockpicking isn’t possible, the locksmith may need to drill into the lock’s cylinder. This will then require replacement of the cylinder or the entire lock.        `,
      },
      {
        tag: 'h3',
        q: `Cut or duplicate keys`,
        a: `Locksmiths are highly trained in cutting and duplicating keys for all kinds of locks, ranging from commercial and residential door locks to safe and window locks. You may need keys cut or duplicated if you have new housemates or would like to give a friend or family member access to your home.
`,
      },
      {
        tag: 'h3',
        q: `Change locks`,
        a: `Often, homeowners may require locks changed when moving, or if a recent burglary attempt has taken place. Landlords also often require lock changes when new tenants move into their property. All professional locksmiths will have the tools and skills on-hand to quickly change locks in the case of moving house or as a response to security concerns.`,
      },
      {
        tag: 'h3',
        q: `Repair locks`,
        a: `Lock repair is a difficult and complex task. Qualified locksmiths can repair locks, such as jammed door locks, using a combination of small, dedicated tools and compressed air to clear the jam. Older locks may require new parts if some components have succumbed to wear and tear.`,
      },
      {
        tag: 'h3',
        q: `Open safes`,
        a: `Locksmiths specialise in working with security safe locks. These locks, understandably, are more complex than the typical door or gate lock. Vault and safe technicians are specifically trained in opening complicated safe locks.`,
      },
      {
        tag: 'h3',
        q: `Unlock cars`,
        a: `Most modern cars use electronic transponder keys, which are prone to breakage over time. Many Australians also know the stress of leaving your keys in the ignition and locking yourself out of the car. A qualified auto locksmith will have transponder programming tools on-hand, which they can use to unlock your car without needing to physically crack the lock. A professional car locksmith can also offer car key replacement services if required.`,
      },
      {
        tag: 'h3',
        q: `Open garage doors`,
        a: `Over time, garage doors are prone to jamming due to gathered dirt, grime, and rust. Locksmiths are trained to respond to emergencies such as malfunctioning garage doors. They can also install locks on shed or garage doors.`,
      },
      {
        tag: 'h3',
        q: `Install or fix gate locks`,
        a: `Installing a quality gate lock is essential for home or business security, and provides safety for children or animals living on the property. Professional locksmiths can install and repair a wide variety of gate locks, including deadlocks, deadlatches, and security latches. Since gate locks are often exposed to the elements, they may require regular maintenance and repair, which a qualified locksmith can provide.`,
      },
      {
        tag: 'h3',
        q: `Install or fix security systems`,
        a: `While locksmiths have traditionally worked with mechanical lock and key systems, modern-day locksmiths are trained in all aspects of electronic security, from smart keys, to FOB keys, to installing and maintaining an advanced home security system.
<br><br>
        Some highly trained locksmiths are also adept in installing and repairing access control systems, for everything from single door applications to large establishments such as apartment complexes, schools, and hospitals.
        `,
      },
    ],
  },
  {
    tag: 'h2',
    heading: 'FAQ about Locksmiths in Australia',
    faqs: [
      {
        tag: 'h3',
        q: 'What should I look for when choosing a locksmith?',
        a: `<h4>Licenses, qualifications, and insurance</h4>
<br>
        To become a professional locksmith under the MLAA, apprentices must undergo expansive training via a combination of TAFE-based and on-the-job training. Only fully qualified, license and insured locksmiths are supported by the MLAA.
        <br><br>
        Insured locksmiths have obtained liability insurance, which protects locksmiths and their clients from problems associated with accidental damage to property or life. Locksmith liability insurance is similar to car insurance. By choosing a licensed and qualified locksmith, you’ll have peace of mind that the work will be completed safely and securely.
        <br><br>
        Furthermore, licensed and qualified locksmiths have the training and knowledge to provide expert, trustworthy advice in all aspects of residential, commercial, and industrial security. MLAA <a href=“https://www.masterlocksmiths.com.au">Master Locksmiths</a> work under a strict code of conduct, meaning they will never overcharge for their services or complete substandard work.
        <br><br>
        <h4>Reviews</h4>
        <br>
        When choosing a locksmith, the first thing you might look at is reviews. This is a smart choice—with so many locksmithing services on the market, it can be hard to know who to choose. Generally, choosing a locksmith who has consistently performed quality services in the past is a safe option. Look out for reviews that discuss the value, speed, level of customer service and quality of the work performed.
        <br><br>
      <h4>Quotes</h4>
      <br>
        Localsearch allows users to obtain quotes for local locksmithing services and compare the best price.
        `,
      },
      {
        tag: 'h3',
        q: 'After-hours or emergency services',
        a: `You may require an emergency locksmith if:<br>
       <ul>
       <li>You have locked yourself out of your home, office or car.</li>
       <li>You need urgent access to a vault or safe, but have forgotten the code.</li>
       <li>A burglary has occurred and you need locks changed</li>
       </ul>
       <br>
        You can also search for after-hours or emergency locksmiths via Localsearch. Many locksmiths offer 24/7 emergency services for urgent problems, such as lost or damaged house or car keys. A mobile locksmith can travel to you with all the necessary tools and solutions on-hand, ready to tackle your emergency quickly and efficiently.
<br><br>
       <h4>Payment methods</h4>
       <br>
        Most locksmiths take a variety of payment methods, including cash, cheque, credit card, bank cheque, EFTPOS, and other digital payment methods. Some locksmiths may apply a surcharge to credit card purchases.
        <br><br>
        To save time, check your locksmith’s preferred payment methods before booking their services. Have enough cash on-hand or money ready to transfer to avoid delays or excess charges.

        `,
      },
      {
        tag: 'h3',
        q: 'How much does a locksmith cost in Australia?',
        a: `The cost of locksmithing services in Australia can vary based on several factors, including the complexity of the job, the time taken and the tools required. Generally, locksmithing services may cost anywhere from $90 to $215 on average, or a rate of about $60 per hour. After-hours or emergency service calls may cost up to $250.
<br><br>
        During working hours, call-out fees average around $110, while late-night, early morning or weekend services may incur call out charges of $150 to $200.`,
      },
      {
        tag: 'h3',
        q: 'Do locksmiths offer emergency or after-hours services?',
        a: `Yes, most locksmiths do offer emergency and after-hours services, although this will come at a greater cost than services offered during normal working hours. `,
      },
      {
        tag: 'h3',
        q: 'What is an auto locksmith?',
        a: `Auto locksmiths work with vehicle locks and keys. If you’ve lost or broken your car keys, locksmiths can create a new key and program it to function with your vehicle. Auto locksmiths can also provide emergency lockpicking services if you lock yourself out of your car or lose your keys.
<br><br>
        Auto locksmiths specialise in modern transponder keys, which work because of a microchip. This microchip is programmed with a special code, which is then used to authenticate your car keys. Over time, transponder keys may stop functioning properly. Expert auto locksmiths can replace or repair transponder keys at a lower cost than buying a new key from the manufacturer.
        `,
      },
      {
        tag: 'h3',
        q: 'Should I change my locks when moving into a new house?',
        a: `Changing the locks when moving into a new house is an important safety step. It’s impossible to know who may have a spare key—the previous owner may have passed copies onto friends and family members—meaning strangers may have access to your home. Changing the locks when moving will help you feel safe and secure in your new home.
<br><br>
        A professional locksmith can change all the locks in your home, including door, window, garage, and gate locks to give your peace of mind. Rekeying is another option, where the locksmith will rearrange the pins inside each lock so old keys will no longer work.
         `,
      },
      {
        tag: 'h3',
        q: 'What is an electronic lock?',
        a: `An electronic lock, also known as an electric lock, is a modern type of lock that operates via an electric current. The electric current is used to power electromagnets, motors, or solenoids (single-coiled electromagnets).
<br><br>
        Electronic locks may replace keys or other mechanical locking systems. These innovative solutions may provide additional quality-of-life features, too, like automation or remote locking and unlocking capabilities. Electronic locks are commonly connected to access control systems.
        `,
      },
      {
        tag: 'h3',
        q: 'What does a commercial locksmith do?',
        a: `Commercial locksmiths are responsible for undertaking and overseeing a range of security-related tasks in commercial spaces. Hiring a professional and fully accredited locksmith to manage the security of your business or commercial space is essential—only qualified locksmiths are equipped with the knowledge and tools to keep yourself, your staff, and your assets safe.
<br><br>
        These responsibilities may include:<br>
       <ul>
       <li>Maintaining business security by maintaining, repairing and replacing various locks and security systems.</li>
       <li>Installing, maintaining and repairing mechanical, digital and keyless entry locks for large commercial buildings.</li>
       <li>24-hour emergency response services for commercial spaces.</li>
       <li>Repair and installation of safe or vault locks for banks and other businesses, including drug safes, office safes, high-security sales, and secure cabinets.</li>
       <li>Master key system services.</li>
       <li>Commercial security system installation and maintenance.</li>
       <li>Installation and maintenance of commercial smart lock systems.</li>
       <li>Installation of security doors.</li>

       </ul>
        `,
      },
    ],
  },
];

export default Chiropractors;
